import { render, staticRenderFns } from "./HouseDetailHeader.vue?vue&type=template&id=4180b8a2&scoped=true&"
import script from "./HouseDetailHeader.vue?vue&type=script&lang=js&"
export * from "./HouseDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./HouseDetailHeader.vue?vue&type=style&index=0&id=4180b8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4180b8a2",
  null
  
)

export default component.exports